import React from 'react'
import './LeagueSummary.css'
import { currencyFormat, getCategoryIcon } from '../Shared/helpers'
import { config } from '../../config'
import { useParams } from "react-router-dom";
import { baseUrl } from '../../hooks/useApi';

function LeagueSummary(props) {

    let { slug } = useParams();

    let bannerUrl = config.ApiUrl + baseUrl + 'getcenterbanner/' + slug;
    let logoUrl = config.ApiUrl + baseUrl + 'getcenterlogo/' + slug;

    let leagueSummary = props.leagueSummary;
    return (
        <>
            <div className="card header-league text-white">
                <img src={bannerUrl} className="card-img league-summary-img" alt="..." />
                <div className="card-img-overlay custom-image-overlay-ver" style={{ display: "flex", alignItems: "flex-end" }}>
                    <div style={{ width: "100%" }}>
                        <div className="row g-0">
                            <div className="col-sm-2 col-3" style={{ display: "flex" }}>
                                <img src={logoUrl} alt="..." className='card-logo-league' style={{ maxWidth: "100%" }} />
                            </div>
                            <div className="col-sm-10 col-9 card-header-league">
                                <div className="card-body card-body-league">
                                    <h2 className="card-title header-league-title">{leagueSummary?.league.name}</h2>
                                    <p className="d-none d-sm-block card-text header-league-text">{leagueSummary?.center?.name}, {leagueSummary?.center?.address}</p>
                                    <p className="d-none d-sm-block card-text header-league-text">{leagueSummary?.league.start} - {leagueSummary?.league.end}</p>
                                    <div>
                                    { leagueSummary?.league.duration > 1 
                                        && <span className="badge rounded-pill league-badge">{leagueSummary?.league.duration} Weeks</span>}
                                    { leagueSummary?.league.duration == 1 
                                        && <span className="badge rounded-pill league-badge">{leagueSummary?.league.duration} Week</span>}
                                        <span className="badge rounded-pill league-badge">{leagueSummary?.league.dayOfWeek}</span>
                                        <span className="badge rounded-pill league-badge">{leagueSummary?.league.time}</span>
                                        <span className="badge rounded-pill league-badge price-badge">{currencyFormat(leagueSummary?.league.price)}</span>
                                        <span className={`badge rounded-pill league-badge category-badge-${leagueSummary?.league.category}`}>{getCategoryIcon(leagueSummary?.league.category)} {leagueSummary?.league.category}</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-block d-sm-none sub-text'>
                <p className="card-text header-league-text">{leagueSummary?.center?.name}, {leagueSummary?.center?.address}</p>
                <p className="card-text header-league-text">{leagueSummary?.league.start} - {leagueSummary?.league.end}</p>
            </div>
        </>
    )
}

export default LeagueSummary
